module.exports = __webpack_public_path__ + "static/media/list-of-basic-colors-german.35275fc2.jpg";